import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_file",
  "use": "icon-control_file-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_file\"><path d=\"M6.75 10.965C7.51 9.752 8.063 8.8 8.407 8.11c.515-1.036.029-1.688-.407-1.915-.436-.227-1.25-.33-1.743.413C5.763 7.352 5 8.72 4.4 9.71c-.601.991-.402 2.737.844 3.358 1.246.62 2.625.45 3.405-.673.78-1.123 2.473-4.03 3.3-5.787.825-1.757.362-2.836-.791-3.533-1.153-.696-2.751-.349-3.594 1.052\" stroke=\"currentColor\" fill=\"transparent\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol